import classNames from 'classnames';
import React from 'react';
import { ButtonLink } from '../../../common/button-link/button-link';
import { Translate } from '../../../translate/translate';
import styles from './footer.scss';

interface Props {
  className?: string;
  isValidButtonDisabled?: boolean;

  onValidateClick(): void;

  onCancelClick(): void;
  onSaveClick(): void;
}

export const Footer: React.FunctionComponent<Props> = ({
  className,
  onValidateClick,
  isValidButtonDisabled,
}: Props) => (
  <div className={classNames(className, styles.footer)}>
    <div className={styles.left}>
      <ButtonLink onClick={onValidateClick} disabled={isValidButtonDisabled}>
        <Translate transKey="components.json-editor-with-toolbar.expand-modal.validate" />
      </ButtonLink>
    </div>
  </div>
);
